import styled from "styled-components"
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined'
import { Box } from "@mui/material"

interface HelperTextProps {
    label: string
}

const CustomHelperText = styled('div')(({ theme }) => ({
    path: {
        fill: '#B00020'
    },
    span: {
        color: '#B00020',
        fontSize: 12,
        paddingLeft: 4
    },
}))

export function HelperText(props: HelperTextProps) {
    return (
        <CustomHelperText>
            <Box position="absolute">
                <ErrorOutlinedIcon sx={{ fontSize: 13 }} />
                <span>{props.label}</span>
            </Box>
        </CustomHelperText>
    )
}